// extracted by mini-css-extract-plugin
export default {"container":"GroupsList_container__0H6pe","table":"GroupsList_table__jlDDX","select":"GroupsList_select__22gM9"};